export default "__VITE_ASSET__cc336eeb__"